import { render } from "./AddApprovisionnementPage.vue?vue&type=template&id=5f5907c1&ts=true"
import script from "./AddApprovisionnementPage.vue?vue&type=script&lang=ts"
export * from "./AddApprovisionnementPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__